// extracted by mini-css-extract-plugin
export default {"verifiedBadge":"VerifiedBadge_verifiedBadge__Of5Il","tooltip":"VerifiedBadge_tooltip__T-vKt"};